import { WindowsSteps } from './steps/windows_steps';
import { Step } from './types/base_step';
import { ProductLine } from '../helpers/home_services.helper';
import { StepName } from './types/step.type';

export function getInitialStep(productLine: ProductLine): Step {
  switch (productLine) {
    case ProductLine.Windows:
      return WindowsSteps[0];
    default:
      return WindowsSteps[0];
  }
}

export function getStepAmounts(productLine: ProductLine): number {
  switch (productLine) {
    case ProductLine.Windows:
      return WindowsSteps.length;
    default:
      return WindowsSteps.length;
  }
}

export function getNextStep(
  productLine: ProductLine,
  currentStepName: StepName
): Step | undefined {
  switch (productLine) {
    case ProductLine.Windows:
      return getWindowsNextStep(currentStepName);
    default:
      return getWindowsNextStep(currentStepName);
  }
}

export function getStepByIndex(
  productLine: ProductLine,
  index: number
): Step | undefined {
  switch (productLine) {
    case ProductLine.Windows:
      return WindowsSteps[index];
    default:
      return WindowsSteps[index];
  }
}

function getWindowsNextStep(currentStepName: StepName): Step | undefined {
  const currentStep = WindowsSteps.find(step => step.name === currentStepName);
  if (!currentStep?.nextStep) return undefined;

  return WindowsSteps.find(step => step.name === currentStep.nextStep);
}
